import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/**
 * Displays a color legend mapping resource names to their assigned colors.
 * Shown in CondensedView's ContextHeader when multiResourceMode is active
 * and more than one real resource exists.
 *
 * @param {Object} props
 * @param {Object} props.colorMap - Map of resource UUID -> { bg, border }
 * @param {Object} props.publicDataMap - Map of resource UUID -> publicData (with resource.name)
 */
export default function ResourceColorLegend({ colorMap, publicDataMap }) {
  if (!colorMap || !publicDataMap) return null;

  const entries = Object.entries(colorMap).filter(
    ([uuid]) => uuid !== 'all-option' && publicDataMap[uuid],
  );

  if (entries.length <= 1) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 1.5,
        mb: 0.5,
      }}
    >
      {entries.map(([uuid, colors]) => (
        <Box
          key={uuid}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
          }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '2px',
              backgroundColor: colors.bg,
              border: `2px solid ${colors.border}`,
              flexShrink: 0,
            }}
          />
          <Typography variant="caption" color="text.secondary" noWrap>
            {publicDataMap[uuid]?.resource?.name}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
